import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap/dist/js/bootstrap.min.js"
import "@popperjs/core/dist/umd/popper.min.js"
import "jquery/dist/jquery.min.js"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import wrapWithProvider from "./wrap-with-provider"
export const wrapRootElement = wrapWithProvider
